import { render, staticRenderFns } from "./ChannelGroupAddChannelModal.vue?vue&type=template&id=9b753094&"
import script from "./ChannelGroupAddChannelModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupAddChannelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports